// extracted by mini-css-extract-plugin
module.exports = {"infoItem":"TaleOfTheTapeInfoItem_infoItem__DmzAM","label":"TaleOfTheTapeInfoItem_label__UPy4U","content":"TaleOfTheTapeInfoItem_content__LDQMy"};